import { Button, withStyles } from '@material-ui/core';

const styles = () => ({
  actionContainer: {
    padding: 16
  },
  button: {
    height: 32
  }
});
const Footer = ({ classes, onClose, label }) => (
  <div className={classes.actionContainer}>
    <Button variant="outlined" color="primary" onClick={onClose} className={classes.button}>
      Close pro info
    </Button>
  </div>
);

export default withStyles(styles)(Footer);
